// modes for creating tasks

export const FOR_LESSON = "TEACHER";
export const FOR_ACADEMY = "ACADEMY";

export const FOR_TEACHER_TOURNAMENT = "TEACHER_FOR_TOURNAMENT";
